import { Input } from "./ui";

const RoomEdit = (props) => {

    const handleChange = (newName)=>{
        props.floorplanningHelper.roomName = newName;
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            width: "180px",
            padding: "10px",
            gap: "5px",
        }}>
            <Input type="text" placeholder="Room Name"
                onChange={(evt)=>{handleChange(evt.target.value)}}
                value = {props.floorplanningHelper.roomName} />
        </div>
    );
}

export default RoomEdit;